import { cva } from "class-variance-authority"

export const buttonVariants = cva(
  "relative group inline-flex items-center justify-center whitespace-nowrap rounded-md text-base font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none border border-transparent",
  {
    variants: {
      variant: {
        default: "bg-brand-primary text-neutral-mainBg hover:bg-brand-primary active:bg-brand-primary",
        destructive: "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",
        outline: "border-neutral-border bg-neutral-mainBg text-indigo-primary/80 hover:bg-neutral-secondBg",
        secondary:
          "bg-brand-mainBg text-brand-primary hover:bg-brand-main-100 hover:text-brand-primary active:bg-brand-mainBg active:text-brand-primary",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline",
        text: "bg-none text-brand-primary hover:bg-brand-mainBg hover:text-brand-primary active:text-brand-primary ",
      },
      size: {
        default: "rounded-[100px] py-4 px-6",
        lg: "rounded-[100px] py-4 px-6",
        md: "rounded-[100px] py-3 px-5",
        sm: "rounded-[100px] py-2 px-4 text-sm",
        lgicon: "py-5 px-5 rounded-full",
        mdicon: "py-3 px-3 rounded-full",
        smicon: "py-1 px-1 rounded-full text-sm",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
)

export const buttonSpinnerVariants = cva("", {
  variants: {
    size: {
      default: "h-10 w-10",
      lg: "h-10 w-10",
      md: "h-8 w-8",
      sm: "h-6 w-6",
      lgicon: "h-10 w-10",
      mdicon: "h-8 w-8",
      smicon: "h-6 w-6",
    },
    defaultVariants: {
      size: "default",
    },
  },
})
